(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-utils/jupiter-helper/assets/jupiter-helper.js') >= 0) return;  svs.modules.push('/components/tb-utils/jupiter-helper/assets/jupiter-helper.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiter;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('module:arena');
} else {
  jupiter = svs.core.jupiter;
  logger = svs.components.tbUtils.jupiterHelper.logger;
}

const streamlinedJupiterCall = async options => {
  let response;
  let status;
  try {
    var _response;
    if (isServer) {
      const apiResponse = await jupiter.callAsync(options);
      status = apiResponse ? 'success' : 'Api response missing';
      response = apiResponse;
    } else {
      ({
        response,
        status
      } = await jupiter.callAsync(options));
    }
    return {
      error: status === 'success' ? null : ((_response = response) === null || _response === void 0 ? void 0 : _response.error) || 'error',
      data: status === 'success' ? response : null
    };
  } catch (err) {
    logger.info("Error getting ".concat(options === null || options === void 0 ? void 0 : options.path), err);
    return {
      error: err,
      data: null
    };
  }
};
const exportedFunctions = {
  streamlinedJupiterCall
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.components.tbUtils.jupiterHelper = exportedFunctions;
}

 })(window);